module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_55.4d97b5d8.png";